var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"personalInfo"},[_vm._m(0),_c('div',{staticClass:"content"},[(_vm.branchIndustry === 'traffic')?_c('trafficPersonalInfoForm'):_c('personalInfoForm')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topTitle"},[_c('span',[_vm._v("我的资料")]),_c('div',{staticClass:"longLine"},[_c('div',{staticClass:"shortLine"})])])
}]

export { render, staticRenderFns }